module.exports = __webpack_public_path__ + "img/Pic_Text_ZTY_Down.86a26524.png";